import { render, staticRenderFns } from "./feedBackDetail.vue?vue&type=template&id=46fc72a1&scoped=true"
import script from "./feedBackDetail.vue?vue&type=script&lang=js"
export * from "./feedBackDetail.vue?vue&type=script&lang=js"
import style0 from "./feedBackDetail.vue?vue&type=style&index=0&id=46fc72a1&prod&lang=scss&scoped=true"
import style1 from "./feedBackDetail.vue?vue&type=style&index=1&id=46fc72a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc72a1",
  null
  
)

export default component.exports